import React from "react";
import InputBox from "../../Login/InputBox";
import { useEffect, useState } from "react";
import {
  signupWithEmail,
  checkUser,
  setDocData,
  getDocData,
} from "../../../utils/firebase/Firebase.utils";
import { updateUserDisplayName } from "../../../utils/firebase/Firebase.utils";
import { createUserDoc } from "../../../utils/firebase/Firebase.utils";
import { FaEye, FaEyeSlash, FaLock, FaEnvelope, FaUser } from "react-icons/fa";
import { MdPrivacyTip } from "react-icons/md";

import { useDispatch } from "react-redux";
import { loadUser } from "../../../store/userSlice";
import { Link, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import PageModal from "../../Dashboard/Components/PageModal";
import PrivacyPage from "../../Login/PrivacyPage";

export default function InvitationForm() {
  const [formData, setFormData] = useState({});
  const { id: InvitationId } = useParams();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [viewMode, setViewMode] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleClickShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword((show) => !show);
  };

  const handleViewPrivacyPolicy = () => {
    setViewMode(!viewMode);
  };

  const checkPasswordFormat = (password) => {
    const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/;
    return regex.test(password);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsProcessing(true);
    const { displayName, email, password, confirm_password } = formData;

    if (password !== confirm_password) {
      toast.error("Passwords do not match");
      setIsProcessing(false);
      return;
    }

    const passwordCheck = checkPasswordFormat(password);
    if (!passwordCheck) {
      toast.error(
        "Password must be at least 8 characters with uppercase, lowercase, and numbers"
      );
      setIsProcessing(false);
      return;
    }

    const signUp = async () => {
      try {
        const res = await signupWithEmail(email, password);
        if (res) {
          const userCheck = await checkUser(res.user);

          if (!userCheck) {
            await createUserDoc(res.user, {
              principalUser: InvitationId,
              displayName,
              roles: ["user"],
            });
            const principalUser = await getDocData("users", InvitationId);
            const linkedIdentifiers = principalUser.linkedIdentifiers || [];
            await setDocData("users", res.user.uid, {
              linkedIdentifiers: [...linkedIdentifiers],
            });
            await updateUserDisplayName(displayName);

            dispatch(
              loadUser({
                email,
                displayName,
                uid: res.user.uid,
                roles: ["user"],
                linkedIdentifiers,
                principalUser: InvitationId,
              })
            );
            toast.success("Registration successful!");
            navigate("/dashboard");
          } else {
            toast.error("User already exists, sign in instead");
          }
        }
      } catch (error) {
        toast.error("Failed to create account. Please try again.");
      }
    };
    signUp();
  };

  return (
    <div className="w-full space-y-4">
      <form className="w-full space-y-4" onSubmit={handleSubmit}>
        <div className="relative">
          <div className="absolute top-10 left-0 pl-3 flex items-center pointer-events-none">
            <FaUser className="text-[#8FCD00] h-5 w-5" />
          </div>
          <InputBox
            label="Full Name"
            type="text"
            placeholder="Enter your full name"
            onChange={handleChange}
            name="displayName"
            className="pl-10"
          />
        </div>

        <div className="relative">
          <div className="absolute top-10 left-0 pl-3 flex items-center pointer-events-none">
            <FaEnvelope className="text-[#8FCD00] h-5 w-5" />
          </div>
          <InputBox
            label="Email Address"
            type="email"
            placeholder="Enter your email address"
            onChange={handleChange}
            name="email"
            className="pl-10"
          />
        </div>

        <div className="relative">
          <div className="absolute top-10 left-0 pl-3 flex items-center pointer-events-none">
            <FaLock className="text-[#8FCD00] h-5 w-5" />
          </div>
          <InputBox
            label="Password"
            type={showPassword ? "text" : "password"}
            placeholder="Enter your password"
            onChange={handleChange}
            name="password"
            className="pl-10"
          />
          <button
            type="button"
            className="absolute top-10 right-2 flex items-center text-gray-400 hover:text-[#363062]"
            onClick={handleClickShowPassword}
          >
            {showPassword ? (
              <FaEyeSlash className="h-5 w-5" />
            ) : (
              <FaEye className="h-5 w-5" />
            )}
          </button>
        </div>

        <div className="relative">
          <div className="absolute top-10 left-0 pl-3 flex items-center pointer-events-none">
            <FaLock className="text-[#8FCD00] h-5 w-5" />
          </div>
          <InputBox
            label="Confirm Password"
            type={showConfirmPassword ? "text" : "password"}
            placeholder="Confirm your password"
            onChange={handleChange}
            name="confirm_password"
            className="pl-10"
          />
          <button
            type="button"
            className="absolute top-10 right-2 flex items-center text-gray-400 hover:text-[#363062]"
            onClick={handleClickShowConfirmPassword}
          >
            {showConfirmPassword ? (
              <FaEyeSlash className="h-5 w-5" />
            ) : (
              <FaEye className="h-5 w-5" />
            )}
          </button>
        </div>

        <button
          type="submit"
          className={`w-full py-3 px-4 rounded-lg text-white font-medium transition-colors ${
            isProcessing
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-[#363062] hover:bg-[#2a2450]"
          }`}
          disabled={isProcessing}
        >
          {isProcessing ? "Creating Account..." : "Complete Registration"}
        </button>

        <div className="text-center text-sm text-gray-600">
          Already have an account?{" "}
          <Link
            to="/login"
            className="text-[#8FCD00] hover:text-[#363062] font-medium"
          >
            Sign in
          </Link>
        </div>

        <div
          className="text-center text-sm text-gray-600 cursor-pointer hover:text-[#363062] flex items-center justify-center gap-1"
          onClick={handleViewPrivacyPolicy}
        >
          <MdPrivacyTip className="h-4 w-4" />
          Privacy Policy and Information
        </div>
      </form>

      {viewMode && (
        <PageModal>
          <PrivacyPage setViewMode={setViewMode} />
        </PageModal>
      )}
    </div>
  );
}
